export default __webpack_public_path__ + "static/media/endGame.ab442f75.svg";